import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Backdrop, CircularProgress } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

function PageLoading({ open, ...rest }) {
  const classes = useStyles();

  return (
    <Backdrop
      className={classes.root}
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={!!open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default PageLoading;
